module.exports = __webpack_public_path__ + "static/img/2.0c31e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/5/2.png
// module id = MDHy
// module chunks = 1